module.exports = __webpack_public_path__ + "img/DC-appointments-mindfulness.f11929ef.svg";